import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./SelectImageDropdown.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
} from "@fortawesome/free-solid-svg-icons";
import SpanInput from "../SpanInput";
import Button from "../Button";
import ImageSectionElement from "../ImageSectionElement";
import ButtonStyledRadioButtonGroup from "../ButtonStyledRadioButtonGroup";
import classNames from "classnames";
import DefaultImage from "../../assests/home-feed-image-coming-soon.jpg";

/**
 * Interactive component.
 * A section editor that allows the user to customize a feed item’s image section.
 */
export function SelectImageDropdown({
  currentPhoto,
  setCurrentPhoto,
  isOpen,
  setIsOpen,
  index,
  setIsModalOpen,
  handleSubmit,
}) {
  const initialAlign = currentPhoto.align || currentPhoto.alignment || "center";
  const [linkValue, setLinkValue] = useState(currentPhoto.link || "");
  const [alignValue, setAlignValue] = useState(initialAlign);
  // const [isModalOpen, setIsModalOpen] = useState(false);

  // Alignment of current/selected photo
  const handleAlignChange = (e) => {
    const align = e.target.value;
    setAlignValue(align);
    setCurrentPhoto((prevPhoto) => ({ ...prevPhoto, align }));
  };

  return (
    <>
      {isOpen ? (
        <div className={styles.container}>
          <div className={styles.topButtonContainer}>
            <div className={styles.buttonAlign}>
              <ButtonStyledRadioButtonGroup
                options={[
                  {
                    value: "left",
                    buttonContent: <FontAwesomeIcon icon={faAlignLeft} />,
                  },
                  {
                    value: "center",
                    buttonContent: <FontAwesomeIcon icon={faAlignCenter} />,
                  },
                  {
                    value: "right",
                    buttonContent: <FontAwesomeIcon icon={faAlignRight} />,
                  },
                ]}
                currentlySelected={alignValue}
                setCurrentlySelected={handleAlignChange}
              />
            </div>

            <div className={styles.link}>
              <SpanInput
                currentValue={linkValue}
                setCurrentValue={(e) => setLinkValue(e.target.value)}
                inputType={"text"}
                inputLabel={"Link"}
                placeholder={" (Optional) "}
              />
            </div>

            <div className={styles.buttonContainer}>
              <Button
                onClick={() => {
                  handleSubmit(alignValue, linkValue, index);
                }}
                text={"Done"}
                className={styles.button}
              />
            </div>
          </div>

          <div
            className={classNames(styles.imageContainer, {
              [styles.alignLeft]: alignValue === "left",
              [styles.alignCenter]: alignValue === "center",
              [styles.alignRight]: alignValue === "right",
            })}
            onClick={() => setIsModalOpen(index, currentPhoto)}
          >
            <ImageSectionElement
              currentPhoto={
                currentPhoto.src === ""
                  ? {
                      src: DefaultImage,
                      align: alignValue,
                      link: linkValue,
                    }
                  : currentPhoto
              }
            />
          </div>
        </div>
      ) : (
        <>
          <div
            onClick={() => {
              setIsOpen(index);
            }}
          >
            <ImageSectionElement currentPhoto={currentPhoto} />
          </div>
        </>
      )}
    </>
  );
}

SelectImageDropdown.propTypes = {
  currentPhoto: PropTypes.shape({
    src: PropTypes.string,
    align: PropTypes.oneOf(["left", "center", "right"]),
    link: PropTypes.string,
  }),
  setCurrentPhoto: PropTypes.func,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
};
